






































































































































import VueOptions from '@utils/VueOptions'
import Modal from '@components/Modal'
import LoadingIndicator from '@/components/LoadingIndicator'
import RequestButton from '@/components/RequestButton'
import AcceptanceBar from '@modules/ui/Offer/actions/AcceptanceBar'
import Back from '@modules/ui/buttons/Back'

import OfferHeader from '@modules/ui/Offer/OfferHeader'
import OfferDetails from '@modules/ui/Offer/steps/OfferDetails'
import BrandProvides from '@modules/ui/Offer/steps/BrandProvides'
import UniversityProvides from '@modules/ui/Offer/steps/UniversityProvides'

import OfferAlertBar from './OfferAlertBar'
import SetOfferShippingAreaTriggerModal from '@triggers/Offer/SetOfferShippingAreaTriggerModal'
import SetOfferBankingContactTriggerModal from '@triggers/Offer/SetOfferBankingContactTriggerModal'

isDev = process.env.NODE_ENV is 'development'

settings =
  name: 'OfferShow'

  resources:
    offer: 
      resourceName: "offer"
      slug: "offers/:offerId"
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:audienceListingId'
      fetch: false
    vendor_listing:
      resourceName: 'vendor_listing'
      slug: 'vendor_listings/:vendorListingId'
      fetch: false

  vue:
    components: {
      OfferAlertBar,
      LoadingIndicator,
      Modal,
      AcceptanceBar,
      Back,
      OfferHeader,
      OfferDetails,
      BrandProvides,
      UniversityProvides,
      RequestButton,
      SetOfferShippingAreaTriggerModal,
      SetOfferBankingContactTriggerModal,
    }

    computed:
      devMode: -> isDev

      audienceListingId: -> @ctxAudienceListing(@offer).id
      vendorListingId: -> @ctxVendorListing(@offer).id
      listing: -> @audience_listing || @vendor_listing

      isProductSampling: ->
        @offer.spaces_purchased[0].includes 'sampling'
      offerProgress: ->
        acceptedCount = 0
        offerAcceptance = true
        acceptedCount++ if @offer.accepted
        for key, agreement of @offer.offer_acceptance_agreement
          offerAcceptance = offerAcceptance and agreement.accepted
          acceptedCount++ if agreement.accepted
        return { count: acceptedCount, accepted: offerAcceptance, percentComplete: Math.round(acceptedCount * 100 / 4) }
      dayExpiresAt: -> dayjs(@offer.expires_at).add(1, 'day')
      isExpired: ->  not @dayExpiresAt.isAfter(dayjs())

      additionalOrganizerTOS: -> @listing?.special_terms

      hasShippingAddress: ->
        @isProductSampling and !!@ctxShippingArea(@offer).id

    data: ->
      dataCollectionKeys: ["name", "email", "phone","grad_year", "dob", "mailing_address"]
      dataCollectionLabels: {name: "Name", email: 'Email', phone: 'Phone', grad_year: 'Graduation Year', dob: 'Date of Birth', mailing_address: 'Mailing Address'}
      openPanel: null
      showMoreOfferActions: false
      acceptanceModal:
        show: false
      denialModal:
        show: false
        reasons: []

    methods:
      onLoadItemCompleted: (resourceKey) ->
        if resourceKey is 'offer'
          if @audienceListingId
            @fetch 'audience_listing'
          else if @vendorListingId
            @fetch 'vendor_listing'

      promptToAccept: -> 
        unless @offerProgress.percentComplete == 75
          @showAlert 'Please read and accept each section of the offer before accepting it!', 'Accept All Offer Sections' 
          return
        if @isExpired
          @showAlert 'This offer is no longer available.', 'Offer Expired' 
          return 

        @acceptanceModal.show = true if @offerProgress.percentComplete == 75
      selectDenialReason: (reason) ->
        if !@denialModal.reasons.includes reason
          @denialModal.reasons.push reason 
        else
          @denialModal.reasons = (r for r in @denialModal.reasons when r isnt reason)
      denialReasonIsSelected: (reason) -> @denialModal.reasons.includes reason
      promptToDeny: -> @denialModal.show = true
      denyOffer: ->
        denial_reasons = @denialModal.reasons
        denial_reasons.push @denialModal.otherReason if @denialModal.otherReason
        @triggerResource 'offer', 'deny', {denial_reasons} if @offer.pending
      revertOffer: ->
        @ifDebug =>
          @triggerResource 'offer', 'revert_choice' if @offer.revertable
          @denialModal?.reasons = []

      onOfferRevertChoice: ->
      acceptOffer: ->
        if not @offerProgress.accepted
          return @showAlert 'Please agree to all of the terms in order to accept this offer.'
        payload = offer_acceptance_agreement: @offer.offer_acceptance_agreement
        @triggerResource 'offer', 'accept', payload if @offer.pending
      onOfferAccept: ->
        document.getElementById('scroll')?.scrollTo(0,0)
        @acceptanceModal.show = false
        @denialModal?.reasons = []
        # @promptToSetBankingContact()
        @promptToSetShippingArea() if @isProductSampling

      onOfferDeny: ->
        @denialModal.show = false
      toggleAcceptance: (key) -> 
        if @isExpired
          @showAlert 'This offer is no longer available.', 'Offer Expired' 
          return 
        if !@offer.pending
          # @showAlert "You can't update this"
          return
        @offer.offer_acceptance_agreement[key].accepted = !@offer.offer_acceptance_agreement[key].accepted
        payload = offer_acceptance_agreement: @offer.offer_acceptance_agreement
        @triggerResource 'offer', 'sign_agreement', payload 
        @acceptanceModal.show = true if @offerProgress.percentComplete == 75
        if @openPanel < 2
          @openPanel++ 
        else 
          @openPanel = null
        # @showAlert "You can now accept this offer!" if @offerProgress.count is 3
      onLoadPrimeCompleted: ->
        @openPanel = 2 if @offer? && !@offer.offer_acceptance_agreement['supplier_provides'].accepted 
        @openPanel = 1 if @offer? && !@offer.offer_acceptance_agreement['sponsor_provides'].accepted 
        @openPanel = 0 if @offer? && !@offer.offer_acceptance_agreement['offer'].accepted 

      hiCheckOther: ->
        if @denialModal.otherReason?.length
          @denialModal.otherReason = ''
          return

        @denialModal = { ...@denialModal, otherReason: 'Other: ' }
        @$refs.otherReason.focus()

      promptToSetShippingArea: ->
        payloadOptions = {}
        modalOptions = { @offer }
        @$refs.setOfferShippingAreaTrigger.fire payloadOptions, modalOptions
      onOfferSetShippingArea: ->
        # @$refs.setOfferShippingAreaTrigger.close()

      promptToSetBankingContact: ->
        payloadOptions = {}
        modalOptions = { @offer }
        @$refs.setOfferBankingContactTrigger.fire payloadOptions, modalOptions
      onOfferSetBankingContact: ->
        @$refs.setOfferBankingContactTrigger.close()

export default VueOptions.vue settings

